import * as React from "react";

import { AssetGridEmpty } from "./EmptyState";

export const NoSearchResults: React.FC<{ searchTerm: string }> = ({
  searchTerm,
}) => {
  return (
    <AssetGridEmpty
      title="No results found"
      description={`for "${searchTerm}"`}
    />
  );
};
